import $ from "cash-dom";
import MagicGrid from "magic-grid";
import Splide from "@splidejs/splide";
import offside from 'offside-js';
import {initNavigationDropdown} from "./navDropdown";


require("fslightbox");

function isMobile(): boolean {
    return window.innerWidth < 640;
}

function showFormSuccessBox() {

    const params = new URLSearchParams(window.location.search);

    if (params.get("form") === "success") {
        $("#form-success").removeClass("hidden");

        pushTrackingEvent("generate_lead", {
            lead_type: "contact_form",
            form_name: "form-contato",
        });

        params.delete("form");
        const query = params.toString();
        const url = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
        window.history.replaceState(null, document.title, url);
    }
}

const TRACKING_PARAM_NAMES: Record<string, string> = {
    trackMethod: "contact_method",
    trackLocation: "cta_location",
    trackLabel: "cta_label",
    trackLeadType: "lead_type",
    trackProductId: "product_id",
    trackProductName: "product_name",
    trackFileName: "file_name",
    trackFileType: "file_type",
    trackFileExtension: "file_extension",
};

let semanticTrackingInitialized = false;

function camelToSnake(input: string): string {
    return input.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

function getTrackingParamName(datasetKey: string): string {
    if (TRACKING_PARAM_NAMES[datasetKey]) {
        return TRACKING_PARAM_NAMES[datasetKey];
    }

    return camelToSnake(datasetKey.replace(/^track/, "")).replace(/^_/, "");
}

function getTrackingParams(target: HTMLElement): Record<string, string> {
    const params: Record<string, string> = {};

    Object.entries(target.dataset).forEach(([key, value]) => {
        if (!key.startsWith("track") || key === "trackEvent" || key === "trackSecondaryEvent" || !value) {
            return;
        }

        params[getTrackingParamName(key)] = value;
    });

    return params;
}

function isContactHref(href: string): boolean {
    if (href.startsWith("tel:") || href.startsWith("mailto:")) {
        return true;
    }

    try {
        const url = new URL(href, window.location.href);
        return ["wa.me", "api.whatsapp.com", "web.whatsapp.com"].includes(url.hostname);
    } catch {
        return false;
    }
}

function pushTrackingEvent(eventName: string, params: Record<string, string> = {}, link?: HTMLAnchorElement) {
    const payload: Record<string, string> = {
        event: eventName,
        page_path: window.location.pathname,
        ...params,
    };

    if (link && !isContactHref(link.href)) {
        payload.link_url = link.href;
    }

    const currentWindow = window as typeof window & { dataLayer?: Array<Record<string, string>> };
    currentWindow.dataLayer = currentWindow.dataLayer || [];
    currentWindow.dataLayer.push(payload);
}

function initSemanticTracking() {
    if (semanticTrackingInitialized) {
        return;
    }

    semanticTrackingInitialized = true;

    document.addEventListener("click", (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        const target = event.target.closest<HTMLElement>("[data-track-event]");
        if (!target) {
            return;
        }

        const eventName = target.dataset.trackEvent;
        if (!eventName) {
            return;
        }

        const params = getTrackingParams(target);
        const link = target instanceof HTMLAnchorElement ? target : target.closest("a");

        pushTrackingEvent(eventName, params, link instanceof HTMLAnchorElement ? link : undefined);

        if (target.dataset.trackSecondaryEvent) {
            pushTrackingEvent(target.dataset.trackSecondaryEvent, params, link instanceof HTMLAnchorElement ? link : undefined);
        }
    });
}

initSemanticTracking();

// Cookie notice (docs/spec/2026-11-03-cookie-notice-ga-pull.md S2): shown until the visitor presses OK.
// Every storage access is in try/catch: localStorage throws when the browser blocks site data.
const COOKIE_NOTICE_KEY = "cookie_notice_ok";

function cookieNoticeDismissed(): boolean {
    try {
        return window.localStorage.getItem(COOKIE_NOTICE_KEY) === "1";
    } catch {
        return false;
    }
}

function rememberCookieNoticeDismissed() {
    try {
        window.localStorage.setItem(COOKIE_NOTICE_KEY, "1");
    } catch {
        // Storage blocked: OK still hides the notice, for this page only.
    }
}

function initCookieNotice() {
    const notice = document.getElementById("cookie-notice");
    const ok = document.getElementById("cookie-notice-ok");
    if (!notice || !ok || cookieNoticeDismissed()) {
        return;
    }

    // Room below the footer, so the fixed notice can't cover its last links (WhatsApp, language).
    const reserveSpace = () => {
        document.body.style.paddingBottom = notice.hidden ? "" : `${notice.offsetHeight + 16}px`;
    };

    notice.hidden = false;
    reserveSpace();
    window.addEventListener("resize", reserveSpace);

    ok.addEventListener("click", () => {
        notice.hidden = true;
        reserveSpace();
        window.removeEventListener("resize", reserveSpace);
        rememberCookieNoticeDismissed();
    });
}

// main.js is deferred, so the DOM is parsed here; no need to wait for window.onload (images).
initCookieNotice();

function initOffside() {
    const offcanvasMenuId = "#sidemenu";
    const slidingElementsSelectorId = "#main";

    offside(offcanvasMenuId, {
        slidingElementsSelector: slidingElementsSelectorId,
        buttonsSelector: "#close-offcanvas, #open-offcanvas",
        slidingSide: "left",


        // fixes initial "flashing" of the menu on load
        beforeOpen: () => {
            $(offcanvasMenuId).removeClass('hidden');
        }

    });
}

function initCarousel() {
    const target = $(".splide").first();
    let lastState = null;
    let lastSplide: Splide = null;

    if (target[0] ?? false) {


        const initSplide = () => {

            if (lastState == isMobile()) {
                window.requestAnimationFrame(initSplide);
                return;
            }
            lastState = isMobile();
            let perPage = isMobile() ? 1 : 3;

            const splideOptions = {
                arrows: true,
                perMove: 1,
                perPage,
                type: 'loop',
                classes: {
                    pagination: 'splide__pagination',
                    page: 'splide__pagination__page !bg-neutral-800'
                }
            };

            if (lastSplide !== null) {
                lastSplide.destroy();
            }

            lastSplide = new Splide(target[0], splideOptions);
            lastSplide.mount();
            window.requestAnimationFrame(initSplide);
        }
        initSplide();
    }

}

window.onload = function (a) {

    initSemanticTracking();
    initCarousel();
    initNavigationDropdown();
    initOffside();
    showFormSuccessBox();

    new MagicGrid({
        container: ".magic-grid",
        static: true,
        animate: true
    }).listen();
}
